/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);

module.exports = canUseDOM;
